import React, { useState, useEffect } from 'react';
import { imageUrl, backdropSize } from '../api';
import { CarouselWrapper, FadeSliderDiv, FaderNav } from './FadeCarousel';
import Loader from '../Loader';
import VideoPlayer from '../VideoPlayer';
import addBtn from '../../imgs/svgs/addBtn.svg';

const HeroHome = ({ heroData, paused, addToList }) => {
  const [slideCount, setSlideCount] = useState(0);
  const [btnClicked, setBtnClicked] = useState(false);
  const [bool, setBool] = useState(false);

  const pauseFader = () => {
    setBool(true);
  };

  const handleClick = (ind, e) => {
    setSlideCount(ind);
    setBtnClicked(true);
  };

  useEffect(() => {
    if (!bool) {
      const timer = setInterval(() => {
        if (btnClicked) {
          setBtnClicked(false);
          clearInterval(timer);
          return;
        } else {
          if (slideCount <= 1) {
            setSlideCount((prev) => prev + 1);
          } else {
            setSlideCount(0);
          }
        }
      }, 5000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [btnClicked, slideCount, bool]);

  if (heroData.length === 0) {
    return <Loader />;
  }
  // this has to come after the above test, else it wont work
  let { id, backdrop_path, overview, title, thumb, video } =
    heroData[slideCount];

  return (
    <>
      <CarouselWrapper>
        <FadeSliderDiv bg={`${imageUrl}${backdropSize.l}${backdrop_path}`}>
          <div className='movie-info'>
            <h1>{title}</h1>
            <p>{overview}</p>
            <div className='btns'>
              <button className='btn'>WATCH NOW</button>
              <button onClick={() => addToList(id)} className='addBtnLg'>
                <span className='round'>
                  <img src={addBtn} alt='Add to my list' />
                </span>
                Add to watch list
              </button>
            </div>
          </div>

          {thumb && (
            <div className='img-wrapper' onClick={pauseFader}>
              <img
                className='vid-thumb'
                src={`${imageUrl}${backdropSize.m}${thumb}`}
                alt={title}
              />
            </div>
          )}
        </FadeSliderDiv>
        <FaderNav>
          {heroData.map((item, index) => {
            return (
              <button
                key={parseInt(item.id + Math.floor(Math.random(2) * 44439))}
                id={index}
                onClick={(e) => handleClick(index, e)}
                className={slideCount === index ? 'active' : ''}
              >
                <span></span>
              </button>
            );
          })}
        </FaderNav>
      </CarouselWrapper>

      {bool && <VideoPlayer video={video} setBool={setBool} />}
    </>
  );
};

export default HeroHome;
